module.exports = __webpack_public_path__ + "static/melting_moments_gib-491d36bf1fdb9a2aa503f868c1ac274a.png";